<template>
  <input-base
    :input="input"
    :applicationValue="applicationValue"
    :review-mode="reviewMode"
    :error="error"
    class="form-wrapper-select"
  >
    <label
      v-for="(option, index) in options"
      :key="index"
      :value="option"
      class="my-3 flex items-baseline border p-2 rounded w-full cursor-pointer"
      :class="{
        'bg-primary-100 border-primary-500': applicationValue == option.key,
        'focus:bg-primary-100 focus:border-primary-500 hover:bg-primary-100 hover:border-primary-500':
          !input.attributes.locked && !reviewMode,
        'opacity-50':
          input.attributes.locked ||
          (reviewMode && applicationValue != option.key)
      }"
    >
      <input
        ref="input"
        type="radio"
        :name="input.key"
        :value="option.key"
        :readonly="input.attributes.locked"
        :required="input.attributes.required"
        :disabled="input.attributes.locked || reviewMode"
        :checked="applicationValue == option.key"
        @change="handleStreamInput(parentField, input.key, $event.target.value)"
      />
      <div class="ml-3">
        <b class="block mb-1 text-lg">{{ option.name }}</b>
        {{ option.description }}
      </div>
    </label>
  </input-base>
</template>

<script>
import { inputHelperMixin } from "../../mixins/inputHelper";
import { competitionStreamsMixin } from "../../mixins/competitionStreams";

export default {
  name: "InputStream",
  mixins: [inputHelperMixin, competitionStreamsMixin],
  computed: {
    options() {
      return this.availableStreams;
    }
  },
  methods: {
    handleStreamInput(parentField, inputKey, value) {
      document.dispatchEvent(new CustomEvent("apc:stream", { detail: value }));
      this.updateInput(parentField, inputKey, value);
    }
  }
};
</script>

<style>
.form-wrapper-select select {
  @apply pr-6 bg-no-repeat cursor-pointer;
  background-position: center right;
  background-image: url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 24 24" height="24px" width="24px" ><g><path fill="currentColor" fill-rule="evenodd" d="M15.3 10.3a1 1 0 0 1 1.4 1.4l-4 4a1 1 0 0 1-1.4 0l-4-4a1 1 0 0 1 1.4-1.4l3.3 3.29 3.3-3.3z" /></g></svg>');
}

.form-wrapper-select:hover .form-wrapper:not(.is-locked) {
  @apply border-primary-400;
}
</style>
